import './chartLabel.less'

import { ChartColors } from '../constants'
import { approximatedValue } from '../../../../utils'
import React from 'react'
import classNames from 'classnames'
import { Typography } from '@lightbeamai/design-system'
import { FormattedNumber } from 'react-intl'

interface IProps {
  count?: number
  text: string
  direction?: 'vertical' | 'horizontal'
  lineColor: ChartColors
  isSelected?: boolean
  onClick?: () => void
  isApproximated?: boolean
}

const ChartLabel: React.FC<IProps> = ({
  count,
  text,
  direction = 'vertical',
  lineColor,
  isSelected,
  onClick,
  isApproximated = false
}) => {
  return (
    <div className={classNames('chart-label-wrapper', { selected: isSelected })}>
      <div
        onClick={onClick}
        className={classNames('chart-label', {
          row: direction === 'horizontal',
          'show-cursor': onClick
        })}
      >
        <span className="label-line" style={{ backgroundColor: lineColor }}></span>
        <div className="label-content">
          <Typography
            className="xs-mb-0"
            color="secondary"
            variant="baseMinus2"
            unsetLineHeight={true}
          >
            {text}
          </Typography>
          {count !== undefined && (
            <Typography className="xs-mt-0" color="primary" unsetLineHeight={true} variant="h5">
              <FormattedNumber value={count} notation="compact">
                {isApproximated ? approximatedValue : undefined}
              </FormattedNumber>
            </Typography>
          )}
        </div>
      </div>
    </div>
  )
}

export default ChartLabel
